import React from 'react'
import { browserHistory } from 'react-router'
import { Link } from 'react-router-dom'
import YouTubePlayer from 'react-player/lib/players/YouTube'

class HomeContent extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			active: false,
			text: false,
			slidesCount: 6,
			activeSlide: 1,
			autoChange: true
		}
	}

	componentDidMount() {
		this.interval = setInterval( this.timer, 5000 )
	}

	componentWillUnmount() {
		clearInterval( this.interval )
	}

	timer = () => {
		const { autoChange, slidesCount, activeSlide } = this.state

		if ( autoChange ) {
			this.setState({
				activeSlide: activeSlide == slidesCount ? 1 : activeSlide + 1
			})
		}
	}

	selectPrev = () => {
		const { slidesCount, activeSlide } = this.state

		this.setState({
			autoChange: false,
			activeSlide: activeSlide == 1 ? slidesCount : activeSlide - 1
		})
	}

	selectNext = () => {
		const { slidesCount, activeSlide } = this.state

		this.setState({
			autoChange: false,
			activeSlide: activeSlide == slidesCount ? 1 : activeSlide + 1
		})
	}

	handleMouseOver = ( e ) => {
		let text = e.currentTarget.getAttribute( 'data-text' )

		this.setState({
			active: true,
			text: text
		})
	}

	render() {
		const { text, activeSlide } = this.state
		// const { text } = this.state

		document.title = siteData.site_name

		const imgURL = siteData.images_url + 'home/'
		// let activeSlide = 4
		let panelClass = ' panel panel-work'
		let panel1Class = ( activeSlide == 1 ? 'panel-1 is-active' : 'panel-1' ) + panelClass
		let panel2Class = ( activeSlide == 2 ? 'panel-2 is-active' : 'panel-2' ) + panelClass
		let panel3Class = ( activeSlide == 3 ? 'panel-3 is-active' : 'panel-3' ) + panelClass
		let panel4Class = ( activeSlide == 4 ? 'panel-4 is-active' : 'panel-4' ) + panelClass
		let panel5Class = ( activeSlide == 5 ? 'panel-5 is-active' : 'panel-5' ) + panelClass
		let panel6Class = ( activeSlide == 6 ? 'panel-6 is-active' : 'panel-6' ) + panelClass

		return (
			<div className="wide-sections">
				<div className="wide-section on-mobile view-ministries">
					<Link to="/ministries" className="button">View Ministries</Link>
				</div>

				<div className="wide-section panels-wrap">
					<div className="panels-info">
						<div className="-text">{ text }</div>
					</div>

					<div className="panels">
						<div className="-work">
							<div className="-inner">
								<div className="-full">
									<a href="http://adra.org.nz/" className={ panel1Class } data-text="ADRA" onMouseOver={ this.handleMouseOver } target="_blank" rel="noopener">
										<div className="-image">
											<img src={ imgURL + 'grid/adra.jpg' } alt="" />
										</div>
									</a>

									<Link to="/communities" className={ panel2Class } data-text="Communities" onMouseOver={ this.handleMouseOver }>
										<div className="-image">
											<img src={ imgURL + 'grid/praying.jpg' } alt="" />
										</div>
									</Link>

									<Link to="/discipleship" className={ panel3Class } data-text="Discipleship" onMouseOver={ this.handleMouseOver }>
										<div className="-image">
											<img src={ imgURL + 'grid/beach.jpg' } alt="" />
										</div>
									</Link>

									<Link to="/education" className={ panel4Class } data-text="Education" onMouseOver={ this.handleMouseOver }>
										<div className="-image">
											<img src={ imgURL + 'grid/education.jpg' } alt="" />
										</div>
									</Link>

									<Link to="/health" className={ panel5Class } data-text="Health" onMouseOver={ this.handleMouseOver }>
										<div className="-image">
											<img src={ imgURL + 'grid/run.jpg' } alt="" />
										</div>
									</Link>

									<a href="https://www.hopechannel.nz/" className={ panel6Class } data-text="Hope Channel" onMouseOver={ this.handleMouseOver } target="_blank" rel="noopener">
										<div className="-image">
											<img src={ imgURL + 'grid/hope.jpg' } alt="" />
										</div>
									</a>
								</div>

								<div className="-columns">
									<a href="http://adra.org.nz/" className={ panel1Class } data-text="ADRA" onMouseOver={ this.handleMouseOver } target="_blank" rel="noopener">
										<div className="-image">
											<img src={ imgURL + 'grid/adra.jpg' } alt="" />
										</div>
									</a>

									<Link to="/communities" className={ panel2Class } data-text="Communities" onMouseOver={ this.handleMouseOver }>
										<div className="-image">
											<img src={ imgURL + 'grid/praying.jpg' } alt="" />
										</div>
									</Link>

									<Link to="/discipleship" className={ panel3Class } data-text="Discipleship" onMouseOver={ this.handleMouseOver }>
										<div className="-image">
											<img src={ imgURL + 'grid/beach.jpg' } alt="" />
										</div>
									</Link>

									<Link to="/education" className={ panel4Class } data-text="Education" onMouseOver={ this.handleMouseOver }>
										<div className="-image">
											<img src={ imgURL + 'grid/education.jpg' } alt="" />
										</div>
									</Link>

									<Link to="/health" className={ panel5Class } data-text="Health" onMouseOver={ this.handleMouseOver }>
										<div className="-image">
											<img src={ imgURL + 'grid/run.jpg' } alt="" />
										</div>
									</Link>

									<a href="https://www.hopechannel.nz/" className={ panel6Class } data-text="Hope Channel" onMouseOver={ this.handleMouseOver } target="_blank" rel="noopener">
										<div className="-image">
											<img src={ imgURL + 'grid/hope.jpg' } alt="" />
										</div>
									</a>
								</div>
							</div>
						</div>

						<div className="-rest">
							<Link to="/about-us" className="panel panel-7" data-text="About Us" onMouseOver={ this.handleMouseOver }>
								<div className="-image">
									<img src={ siteData.images_url + 'logo/symbol/adventist_symbol_white_tm.svg' } alt="" />
								</div>
							</Link>
						</div>
					</div>
				</div>

				<div className="wide-section wide-section-a">
					<div className="-bg">
						<img src={ imgURL + 'island.jpg' } alt="" />
					</div>

					<main>
						<h2>A Worldwide Family of Believers</h2>

						<p>
							Seventh-day Adventists can truly be regarded as a worldwide family of Christian believers. The Adventist presence manifests itself in nearly every country of the globe. Administratively, the church is served through its 13 regional areas of the world. No matter where you find a Seventh-day Adventist believer, you will find them to adhere to the ideals described by the Bible and their lives illustrating both faith in God and the church’s commitment to the betterment of all human beings.
						</p>
					</main>

					<aside>
						<div className="media-player">
							<YouTubePlayer url="https://www.youtube.com/watch?v=Twx1YQi-0AE" controls={ true } />
						</div>
					</aside>
				</div>

				<div className="wide-section wide-section-b">
					{/*<div className="-bg">
						<img src={ imgURL + 'health.jpg' } alt="" />
					</div>*/}

					<aside className="on-not-mobile">
						<Link to="/about-us/">
							<img src={ imgURL + 'worship.jpg' } alt="" />
						</Link>
					</aside>

					<main>
						<div className="-text-a">
							<h2>A new member every 35 seconds</h2>

							<p>
								Seventh-day Adventists are a growing church. Currently the growth rate is almost one million every year, with new members joining the church at a rate of one every 35 seconds. Globally, the church is doubling in size every 12 years.
							</p>
						</div>

						<div className="-text-b">

						</div>
					</main>
				</div>

				<div className="wide-section wide-section-a -reverse">
					<div className="-bg">
						<img src={ imgURL + 'island.jpg' } alt="" />
					</div>

					<aside>
						<div className="media-player media-player-video">
							<div className="youtube-video">
								<YouTubePlayer url="https://www.youtube.com/watch?v=LTGrPByx_i8" controls={ true } />
							</div>
						</div>
					</aside>

					<main>
						<h2>Jayson Rogers' Journey with Jesus</h2>

						<p>
							Be inspired and discover God’s power as you watch Jayson’s Journey with Jesus.
						</p>
					</main>
				</div>

				{/*<div className="wide-section wide-section-text">
					<main>
						<h2>Find Out More</h2>

						<p>
							At risus viverra adipiscing at in tellus integer feugiat. Netus et malesuada fames ac turpis egestas. Quam viverra orci sagittis eu volutpat odio facilisis mauris sit. Urna id volutpat lacus laoreet non curabitur gravida arcu ac. Nibh mauris cursus mattis molestie a iaculis at erat.
						</p>
					</main>
				</div>*/}
			</div>
		)
	}
}

export default HomeContent



// WEBPACK FOOTER //
// ./views/main/home/HomeContent.jsx